import type { GridApi } from "@mui/x-data-grid-premium";
import type { MutableRefObject } from "react";
import { EnabledTablePlugins, TablePlugin } from "ui/molecules/TableGrids/Props";
import useCopyToClipboard, { CopyToClipboardSettings } from "./useCopyToClipboard";

export default function usePlugins(gridApiRef: MutableRefObject<GridApi>, pluginSettings: EnabledTablePlugins) {
    useCopyToClipboard(gridApiRef, pluginSettings[TablePlugin.CopyToClipboard] as CopyToClipboardSettings);
};
